import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { Lead } from 'models/Lead';
import MessageFile from 'components/MessageFiles/components/MessageFile';
import LeadsContext from '../../../../providers/Leads';
import api from 'api';

import './NdaStatusProofFiles.styles.scss';

type NdaStatusProofFilesProps = {
  className?: string;
  lead: Lead;
  dataRoomId: string;
  dataRoomName: string;
};

const NdaStatusProofFiles: React.FC<NdaStatusProofFilesProps> = (props) => {
  const { className, lead, dataRoomId, dataRoomName } = props;

  const classes = classNames('nda-status-proof-files', className);

  const { updateLead } = useContext(LeadsContext);

  const { ndaFile, isDataRoomFile, canMoveFileToDataRoom } = lead || {};

  const { _id, type, originalType, name, url } = ndaFile || {};

  const onFilePreview = useCallback(
    () => api.portfolio.seller.previewNdaProofFile(lead._id),
    [lead?._id],
  );

  const onFileRemove = useCallback(
    async (fileId: string, removeFromDataRoom?: boolean) => {
      await api.portfolio.seller.removeNdaProofFile(
        lead._id,
        fileId,
        removeFromDataRoom,
      );
      updateLead({
        ...lead,
        ndaFile: undefined,
      });
    },
    [lead, updateLead],
  );

  const onFileAddToDataRoom = useCallback(async () => {
    await api.portfolio.seller.moveNdaProofFileToDataRoom(lead._id);
    updateLead({
      ...lead,
      isDataRoomFile: true,
    });
  }, [lead, updateLead]);

  if (!ndaFile) return null;

  return (
    <MessageFile
      className={classes}
      key={_id}
      id={_id}
      name={name}
      url={url}
      dataRoomId={dataRoomId}
      dataRoomName={dataRoomName}
      type={originalType || type}
      isDataRoomFile={isDataRoomFile}
      canMoveFileToDataRoom={canMoveFileToDataRoom}
      canRemoveFile={canMoveFileToDataRoom}
      onFilePreview={onFilePreview}
      onFileRemove={onFileRemove}
      onFileAddToDataRoom={onFileAddToDataRoom}
    />
  );
};

export default NdaStatusProofFiles;
